<template class="page">
  <div class="left-container">
    <h1 class="event-name">
      {{ eventInfo.eventTitle }}
    </h1>
    <div>
      <p class="text" style="font-weight: 800">{{ formatDate(eventInfo.from) }},</p>
      <div class="about-container">
        <p class="text-bold">{{ eventInfo.venue }}</p>
      </div>
      <p class="text">{{ eventInfo.eventAddress }}</p>
    </div>
    <div>
      <div class="about-container" style="width: 500px !important">
        <p class="text-bold">Ulaznica:</p>
        <p class="text">{{ ticketInfo.orderItem.price }} €</p>
      </div>
      <p class="text">Red: {{ getLocationInfo('row') }} Sjedalo: {{ getLocationInfo('seat') }}</p>
    </div>
    <div style="display: flex; gap: 1rem; padding: 0 8px 8px 0">
      <canvas ref="qrcode" class="qrcode" />
      <div style="display: flex; flex-direction: column">
        <img
          src="../../../public/assets/CoreEvent-logo-black.svg"
          class="coreevent-logo"
          alt="CoreEvent logo"
        />
        <p class="text" style="font-size: 14px">
          Kupi ulaznice na<br />
          <b> www.core-event.co</b>
        </p>
        <p class="text" style="font-size: 14px">
          Ulaznica vrijedi kao vaučer u iznosu 5 eura za kupnju u festivalskoj knjižari ili Knjižari
          Fraktura do 21.9.2024.
        </p>
        <p class="text" style="font-size: 14px">Organizator:</p>
        <p class="text-bold" style="font-size: 10px">FRAKTURA</p>
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcode'
import moment from 'moment/moment'

export default {
  name: 'fraktura-ticket-seller-pdf',
  props: {
    eventInfo: Object,
    organization: Object,
    ticketInfo: Object,
    index: Number,
  },
  data() {
    return {
      totalPriceRounded: null,
    }
  },
  async mounted() {
    this.generateQrCode(this.fiscalisationInfo)
    this.loading = false
  },
  methods: {
    async generateQrCode(data) {
      const canvas = this.$refs.qrcode

      return QRCode.toDataURL(canvas, this.ticketInfo.accreditation.qrcode.toString(), {
        width: 75,
        margin: 0,
      })
    },
    getLocationInfo(searchTerm) {
      return (this.ticketInfo.accreditation.ticketLocation || 'Section-Sredina_Row-1_Seat-1')
        .toLowerCase()
        .split('_')
        .filter(loc => loc.includes(searchTerm))[0]
        .split('-')[1]
    },
    formatDate(date) {
      return moment(date).tz('Europe/Zagreb').format(`DD.MM.YYYY. u HH:mm [h]`)
    },
  },
}
</script>

<style scoped>
.left-container {
  margin-left: 1rem;
  margin-right: 3rem;
  background: white;
  display: flex;
  gap: 2rem;
  margin-top: 1rem;
  flex-direction: column;
  width: 5.09cm;
}
.text-bold {
  color: #333;
  font-family: 'National Regular';
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 108%;
  letter-spacing: -0.48px;
}
.text {
  color: #333;
  font-family: 'National Regular';
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 108%; /* 17.28px */
  letter-spacing: -0.48px;
}
.about-container {
  display: flex;
  gap: 0.5rem;
}
.event-name {
  color: #333;
  font-family: 'National Regular';
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: 108%; /* 21.6px */
  letter-spacing: -0.6px;
  width: 400px;
}
.coreevent-logo {
  width: 55px;
  position: absolute;
  left: 86%;
  top: 48%;
  height: 31px;
}
p {
  margin-bottom: 0;
}
</style>
